// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39h3E","clinicsSelect":"styles_clinicsSelect__2RxdG"};